// extracted by css-extract-rspack-plugin
export default {"optionsList":"dm9_e","optionItem":"Dz2tW"};